(function () {
  'use strict';

  function ensureCartCountBadge(count) {
    var cartLink = document.querySelector('#nav-item-cart > a, #nav-item-cart a[href*="/cart"]');
    if (!cartLink) return;

    cartLink.style.position = 'relative';

    var badge = cartLink.querySelector('.cw-cart-count-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cw-cart-count-badge';
      badge.style.position = 'absolute';
      badge.style.top = '-2px';
      badge.style.right = '-2px';
      badge.style.minWidth = '18px';
      badge.style.height = '18px';
      badge.style.padding = '0 5px';
      badge.style.borderRadius = '999px';
      badge.style.display = 'inline-flex';
      badge.style.alignItems = 'center';
      badge.style.justifyContent = 'center';
      badge.style.fontSize = '10px';
      badge.style.lineHeight = '1';
      badge.style.fontWeight = '700';
      badge.style.background = '#111';
      badge.style.color = '#fff';
      badge.style.border = '2px solid #fff';
      badge.style.zIndex = '5';
      cartLink.appendChild(badge);
    }

    badge.textContent = String(count || 0);
    badge.setAttribute('aria-label', String(count || 0) + ((count || 0) === 1 ? ' item in cart' : ' items in cart'));
    badge.style.display = Number(count) > 0 ? 'inline-flex' : 'none';
  }

  function refreshCartCountBadge() {
    fetch(getRoot() + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        ensureCartCountBadge(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);
      })
      .catch(function () {});
  }

  function getRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function parseVariants(form) {
    var node = form.querySelector('.cw-product-variants-json');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getSelectedOptions(form) {
    var groups = {};
    form.querySelectorAll('.rt-pdp-value-btn.active').forEach(function (button) {
      groups[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
    });
    return Object.keys(groups)
      .map(Number)
      .sort(function (a, b) { return a - b; })
      .map(function (index) { return groups[index]; });
  }

  function findVariant(form) {
    var variants = parseVariants(form);
    var selected = getSelectedOptions(form);

    if (!selected.length && variants.length) {
      var currentId = String((form.querySelector('.cw-pdp-variant-id') || {}).value || '');
      return variants.find(function (variant) {
        return String(variant.id) === currentId;
      }) || variants[0];
    }

    return variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selected.length) return false;
      return variant.options.every(function (value, index) {
        return String(value) === String(selected[index]);
      });
    });
  }

  function setButtonAvailability(form, variant) {
    var addButton = form.querySelector('.rt-pdp-add-to-cart-btn');
    var buyButton = form.querySelector('.rt-pdp-buy-now-btn');
    var available = Boolean(variant && (variant.sellable === true || variant.available === true));

    if (addButton) {
      addButton.disabled = !available;
      var label = addButton.querySelector('.add-to-cart-btn-text-add');
      if (label) label.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }

    if (buyButton) {
      buyButton.disabled = !available;
    }

    var stickyButton = document.querySelector('#product-sticky-atc .add-to-cart-btn');
    if (stickyButton) {
      stickyButton.disabled = !available;
    }

    var notice = document.querySelector('.rt-pdp-stock-notice');
    if (notice) {
      notice.style.backgroundColor = available ? '' : '#fef2f2';
      notice.style.borderColor = available ? '' : '#fecaca';
      notice.style.color = available ? '' : '#991b1b';
      var noticeText = notice.querySelector('span');
      if (noticeText) {
        noticeText.textContent = available ? 'In Stock & Ready to Ship' : 'Currently Out of Stock. Back in Stock Soon';
      }
    }
  }

  function syncVariant(form) {
    var variant = findVariant(form);
    if (!variant) return;

    var idInput = form.querySelector('.cw-pdp-variant-id');
    if (idInput) idInput.value = variant.id;

    var stickySelect = document.querySelector('#product-sticky-atc select[name="id"]');
    if (stickySelect && stickySelect.querySelector('option[value="' + variant.id + '"]')) {
      stickySelect.value = String(variant.id);
    }

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var price = document.querySelector('.rt-pdp-price');
      if (price) price.textContent = Shopify.formatMoney(variant.price);
      var compare = document.querySelector('.rt-pdp-compare-price');
      if (compare && variant.compare_at_price) {
        compare.textContent = Shopify.formatMoney(variant.compare_at_price);
      }
    }

    setButtonAvailability(form, variant);

    if (window.history && history.replaceState) {
      var url = form.dataset.productUrl || window.location.pathname;
      history.replaceState(null, '', url + '?variant=' + variant.id);
    }
  }

  function setMessage(form, message, isError) {
    var box = form.querySelector('.cw-pdp-cart-message');
    if (!box) return;
    box.textContent = message || '';
    box.style.display = message ? 'block' : 'none';
    box.style.color = isError ? '#b42318' : '#027a48';
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');

    var addText = button.querySelector('.add-to-cart-btn-text-add');
    var addLoading = button.querySelector('.add-to-cart-btn-text-loading');
    var buyText = button.querySelector('.buy-now-btn-text-add');
    var buyLoading = button.querySelector('.buy-now-btn-text-loading');

    if (addText) addText.hidden = busy;
    if (addLoading) addLoading.hidden = !busy;
    if (buyText) buyText.hidden = busy;
    if (buyLoading) buyLoading.hidden = !busy;
  }

  async function addVariant(variantId, quantity) {
    var response = await fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: Math.max(1, Number(quantity) || 1)
        }]
      })
    });

    var data = await response.json().catch(function () { return {}; });

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Unable to add this item to your cart.');
    }

    return data;
  }

  document.addEventListener('click', function (event) {
    var optionButton = event.target.closest('.rt-pdp-value-btn');
    if (optionButton) {
      var form = optionButton.closest('.rt-pdp-form');
      if (!form) return;

      event.preventDefault();
      var index = optionButton.dataset.optionIndex;
      form.querySelectorAll('.rt-pdp-value-btn[data-option-index="' + index + '"]').forEach(function (button) {
        button.classList.remove('active');
      });
      optionButton.classList.add('active');
      syncVariant(form);
      return;
    }

    var stickyButton = event.target.closest('#product-sticky-atc .add-to-cart-btn');
    if (!stickyButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var sticky = stickyButton.closest('#product-sticky-atc');
    var select = sticky ? sticky.querySelector('select[name="id"]') : null;
    var variantId = select ? select.value : '';
    if (!variantId) return;

    setBusy(stickyButton, true);
    addVariant(variantId, 1)
      .then(function () {
        window.location.href = getRoot() + 'cart';
      })
      .catch(function (error) {
        setBusy(stickyButton, false);
        window.alert(error.message);
      });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.rt-pdp-form');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var idInput = form.querySelector('.cw-pdp-variant-id');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var submitter = event.submitter || form.querySelector('.rt-pdp-add-to-cart-btn');
    var variantId = idInput ? idInput.value : '';

    if (!variantId) {
      setMessage(form, 'Please select an available option.', true);
      return;
    }

    setMessage(form, '', false);
    setBusy(submitter, true);

    addVariant(variantId, quantityInput ? quantityInput.value : 1)
      .then(function () {
        var action = submitter && submitter.dataset.cartAction;
        if (action === 'buy-now') {
          window.location.href = '/checkout';
        } else {
          window.location.href = form.dataset.cartUrl || (getRoot() + 'cart');
        }
      })
      .catch(function (error) {
        setBusy(submitter, false);
        setMessage(form, error.message, true);
      });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rt-pdp-form').forEach(function (form) {
      syncVariant(form);
    });
    refreshCartCountBadge();
  });
})();